import { Dialog } from '@machobear/design-system'
import { DialogEventHandler } from '@/types'
import queryClient from '@/components/query-client'
import CheckoutModalContent from './modal-content'

type Props = {
  visible: boolean
  title: string
  closeModal: DialogEventHandler
  queryKeys?: string[]
}

const CheckoutModal = ({ visible, title, closeModal, queryKeys }: Props) => {
  const handleClose = () => {
    queryClient.invalidateQueries({
      queryKey: ['dryRun'],
      exact: false
    })
    closeModal()
  }
  return (
    <Dialog id="checkoutModal" open={visible} onClose={handleClose} width="large" title={title}>
      <CheckoutModalContent closeModal={closeModal} queryKeys={queryKeys} />
    </Dialog>
  )
}

export default CheckoutModal
